import {createContext, useContext} from "react";

const HeaderImageContext = createContext<boolean>(true);

export const useHeaderImage = () => useContext(HeaderImageContext);

export const HeaderImageProvider = HeaderImageContext.Provider;